var map = {
	"./illu-brain.svg": "6350",
	"./illu-cut-head.svg": "5042",
	"./illu-cut.svg": "0a38",
	"./illu-heart.svg": "b1a7",
	"./illu-hole-full.svg": "70d1",
	"./illu-hole-mask.svg": "2789",
	"./illu-hole-shadow.svg": "fb2c",
	"./illu-hole.svg": "0dc8",
	"./illu-home.svg": "a9f5",
	"./illu-intestine-lg.svg": "ed6a",
	"./illu-intestine-sm.svg": "a62e",
	"./illu-intestine-tooltips.svg": "8e2e",
	"./illu-kidneys.svg": "31f3",
	"./illu-liver.svg": "32c3",
	"./illu-lungs.svg": "7618",
	"./illu-scale-bottom.svg": "2e5a",
	"./illu-scale-top.svg": "592b",
	"./illu-step2.svg": "9aaa",
	"./illu-step5-brain.svg": "53e9",
	"./illu-step5-head.svg": "2d26",
	"./illu-step5-nobrain.svg": "9bf7",
	"./illu-stitches-head.svg": "bcf6",
	"./illu-stitches.svg": "3222",
	"./illu-stomach.svg": "1445",
	"./illu-table.svg": "99ba",
	"./illu-tray-sm.svg": "a1a0",
	"./illu-tray.svg": "cf59"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fa5d";